import { TYPO } from "styles/Typo";
import { 누적합시리즈생성함수 } from "./PerformanceCharts";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";
import moment from "moment-timezone";
import useStrategyPeriod, {
  useStrategyDaily,
} from "utils/clientAPIs/strategyDaliy";
import { exponential } from "utils/exp";
import { KOREA } from "utils/constant/ITME_INFO";
function OperationPeriodCards({
  periodReturn,
  logData,
  xaxisData,
  startDate,
  month,
  items,
  lastDay,
}: {
  periodReturn?: number;
  logData?: any;
  xaxisData?: any;
  startDate: string;
  month: string;
  items: any;
  lastDay: string;
}) {
  const isRealtime = items?.every(
    (item: any) =>
      item?.PRICE_CHG_LOG ||
      String(item?.PRICE_CHG_LOG) === "0" ||
      String(item?.PRICE_CHG_LOG) === "0.0"
  );
  const isNo_ADJ_CLOSE_CHG = items?.every((item: any) => !item?.ADJ_CLOSE_CHG); // 운영 회차 바뀌고 수익률이 한개도 없는 경우
  const { data, isLoading, error } = useStrategyPeriod({
    startdate: startDate,
    month: month,
    loc: KOREA,
  });
  const {
    data: dailyData,
    isLoading: dailyIsLoading,
    error: dailyError,
  } = useStrategyDaily({
    tickers: items?.map((item: any) => item?.ITEM_CD_DL),
    enabled: !isRealtime && !isNo_ADJ_CLOSE_CHG,
  });
  const endDate = data?.enddate;
  const totalDays = data?.totalDays;
  const leftDateCount = totalDays - xaxisData.length;
  const emptyDataset = leftDateCount ? Array(leftDateCount).fill(null) : [];
  const initSeires = 누적합시리즈생성함수(logData);
  const realData = logData ? [...initSeires] : [];
  const seriesData = [...realData, ...emptyDataset];
  const xSeriesData = [...xaxisData, ...emptyDataset];
  const realLastData = realData?.[realData.length - 1];
  const realLastDataIndex = realData?.length - 1;

  const currrentStatus = () => {
    const today = moment().tz("Asia/Seoul").format("YYYY-MM-DD");
    if ((today === lastDay && !isNo_ADJ_CLOSE_CHG) || isRealtime) {
      return "오늘";
    } else if (isNo_ADJ_CLOSE_CHG)
      return moment(startDate).tz("Asia/Seoul").format("M월 D일");
    else return moment(lastDay).tz("Asia/Seoul").format("M월 D일");
  };

  const Card = ({
    children,
    ...props
  }: { children?: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>) => {
    return (
      <div
        className="bg-gray2 flex flex-col rounded-[16px] border border-gray15 px-[14px] py-4 grow flex-1 h-[174px] "
        {...props}
      >
        {children ? children : null}
      </div>
    );
  };

  const highItemList =
    isRealtime && !isNo_ADJ_CLOSE_CHG
      ? [...(items ?? [])].sort(
          (a: any, b: any) => b.PRICE_CHG_LOG - a.PRICE_CHG_LOG
        )
      : isNo_ADJ_CLOSE_CHG
      ? null
      : items
          ?.map((item: any) => {
            return {
              ...item,
              PRICE_CHG_LOG:
                dailyData?.find((d: any) => d?.ITEM_CD_DL === item?.ITEM_CD_DL)
                  ?.DAILY_LOG_RETURN || null,
            };
          })
          ?.sort((a: any, b: any) => {
            return b.PRICE_CHG_LOG - a.PRICE_CHG_LOG;
          });

  const todayTotalProfit = highItemList?.length
    ? exponential(
        highItemList?.reduce((acc: any, curr: any) => {
          return acc + curr?.PRICE_CHG_LOG;
        }, 0) / highItemList?.length
      )
    : null;

  if (dailyIsLoading || isLoading) {
    return (
      <div className="px-6 py-4 flex items-center gap-2">
        <Card />
        <Card />
      </div>
    );
  }

  return (
    <div className="px-6 py-4 flex items-center gap-2">
      <Card>
        <div className="flex flex-col gap-3 justify-between h-full">
          <div>
            <p className={`${TYPO.TYPO6_MD} text-gray80`}>이번달</p>
            <p
              className={`${TYPO.TYPO4_MD} ${
                periodReturn
                  ? Number(periodReturn.toFixed(1)) === 0
                    ? "text-gray50"
                    : periodReturn > 0
                    ? "text-red40"
                    : "text-blue40"
                  : "text-gray50"
              }`}
            >
              {periodReturn ? (periodReturn > 0 ? "+" : "") : ""}
              {periodReturn
                ? Number(periodReturn.toFixed(1)) === 0
                  ? "0%"
                  : `${periodReturn.toFixed(1)}%`
                : "0%"}
            </p>
          </div>
          <div className="grow">
            <Chart
              seriesData={seriesData}
              xaxisData={xSeriesData}
              realLastData={realLastData}
              startDate={startDate}
              endDate={endDate}
              realLastDataIndex={realLastDataIndex}
            />
          </div>
        </div>
      </Card>
      <Card>
        <div className="flex flex-col gap-3 justify-between h-full">
          <div>
            <p className={`${TYPO.TYPO6_MD} text-gray80`}>{currrentStatus()}</p>
            <p
              className={`${TYPO.TYPO4_MD} ${
                todayTotalProfit
                  ? Number(todayTotalProfit.toFixed(1)) === 0
                    ? "text-gray50"
                    : todayTotalProfit > 0
                    ? "text-red40"
                    : "text-blue40"
                  : "text-gray50"
              }`}
            >
              {todayTotalProfit
                ? Number(todayTotalProfit.toFixed(1)) === 0
                  ? ""
                  : todayTotalProfit > 0
                  ? "+"
                  : ""
                : ""}
              {todayTotalProfit
                ? Number(todayTotalProfit.toFixed(1)) === 0
                  ? "0%"
                  : `${todayTotalProfit.toFixed(1)}%`
                : "0%"}
            </p>
          </div>
          {todayTotalProfit !== null &&
          todayTotalProfit !== undefined &&
          highItemList?.length > 0 ? (
            todayTotalProfit > 0 ? (
              <div className="flex flex-col gap-1">
                {highItemList
                  ?.filter((item: any) => exponential(item?.PRICE_CHG_LOG) > 0)
                  .slice(0, 3)
                  ?.map((item: any) => (
                    <div
                      key={item?.ITEM_CD_DL}
                      className="flex items-center justify-between gap-1"
                    >
                      <p
                        className={`${TYPO.TYPO8_RG} text-gray70 whitespace-nowrap truncate`}
                      >
                        {item?.ITEM_KR_NM}
                      </p>
                      <UpIcon />
                    </div>
                  ))}
              </div>
            ) : (
              <div className="flex justify-center items-center  flex-col gap-1">
                <SorryIcon />
                <p className={`${TYPO.TYPO8_RG} text-gray70`}>
                  더 노력하겠습니다
                </p>
              </div>
            )
          ) : null}
        </div>
      </Card>
    </div>
  );
}

const Chart = ({
  seriesData,
  xaxisData,
  realLastData,
  startDate,
  endDate,
  realLastDataIndex,
}: {
  seriesData: any;
  xaxisData: any;
  realLastData: any;
  startDate: any;
  endDate: any;
  realLastDataIndex: number;
}) => {
  const min = seriesData?.reduce((acc: any, curr: any) => {
    return Math.min(acc, curr);
  }, 0);
  const max = seriesData?.reduce((acc: any, curr: any) => {
    return Math.max(acc, curr);
  }, 0);

  const markerSeries = seriesData?.map((item: any, index: number) => {
    const isLastPot = index === realLastDataIndex;
    return {
      y: item,
      marker: {
        enabled: isLastPot,
        fillColor:
          realLastData > 0
            ? TAILWIND_TO_CSS["red40"]
            : TAILWIND_TO_CSS["blue40"],
        lineWidth: 2,
        lineColor:
          realLastData > 0
            ? "rgba(247, 196, 200, 1)"
            : "rgba(196, 200, 247, 1)",
        radius: 3,
      },
    };
  });
  const options: Highcharts.Options = {
    series: [
      {
        type: "spline",
        name: "STRATEGY",
        data: [...markerSeries],
        marker: {
          enabled: false, // marker 제거
        },
        color:
          realLastData > 0
            ? TAILWIND_TO_CSS["red40"]
            : TAILWIND_TO_CSS["blue40"],
        lineWidth: 2,
        zIndex: 3,
      },
    ],
    xAxis: {
      maxPadding: 0.001,
      categories: xaxisData,
      type: "linear", // x축을 순차적으로 표시
      tickLength: 0, // x축 tick 숨기기
      lineWidth: 0, // x축 선 숨기기
      tickPositions: [0, xaxisData.length - 1], // 첫 번째와 마지막 위치만 표시
      labels: {
        enabled: false,
        useHTML: true,
        y: 20,
        formatter: function (this: any) {
          // 첫 번째와 마지막 위치만 라벨 표시
          if (this.pos === 0) {
            return `<span class="text-gray50 ${TYPO.TYPO10_RG} ">${moment(
              startDate
            ).format("M.D")}</span>`;
          } else if (this.pos === this.axis.categories.length - 1) {
            return `<span  class="text-gray50 ${TYPO.TYPO10_RG}">${moment(
              endDate
            ).format("M.D")}</span>`;
          } else {
            return ""; // 중간 라벨들은 숨김
          }
        },
      },
    },
    yAxis: {
      startOnTick: false, // y축의 시작점을 정확한 min 값으로 설정
      endOnTick: false, // y축의 끝점을 정확한 max 값으로 설정
      gridLineWidth: 0,
      title: {
        text: "",
      },
      min: min,
      max: max,

      tickAmount: 5, // y축 눈금 개수
      opposite: true,
      plotLines: [
        {
          value: 0,
          color: TAILWIND_TO_CSS["gray30"],
          width: 0.7,
          dashStyle: "Dash", // 점선 스타일
        },
      ],
      labels: {
        enabled: false,
      },
    },
    tooltip: {
      enabled: false,
    },
    chart: {
      type: "spline",
      backgroundColor: "transparent",
      spacingRight: 0,
      //   spacingBottom: 20, // x축 라벨을 위한 공간 확보
      //   spacingTop: 50,
      spacingLeft: 0,

      marginBottom: 10,
      height: 56, // 차트 높이 증가
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true, // 항상 마커(꼬리)를 보이게 설정
          states: {
            hover: {
              enabled: false, // Hover 시 상태 변경 비활성화
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        dataGrouping: {
          enabled: false, // 데이터 그룹화 비활성화
        },
        states: {
          inactive: {
            opacity: 1,
          },
          hover: {
            enabled: false,
          },
        },
      },
      line: {
        marker: {
          enabled: false,
        },
      },
    },

    title: {
      text: undefined, // 타이틀 제거
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false, // 내보내기 버튼(햄버거 모양 아이콘) 비활성화
    },
    credits: {
      enabled: false,
    },
  };
  return (
    <div className=" ">
      <HighchartsReact highcharts={Highcharts} options={options} />
      <div className="flex justify-between">
        <span className={`text-gray50 ${TYPO.TYPO10_RG} `}>
          {moment(startDate).format("M.D")}
        </span>
        <span className={`text-gray50 ${TYPO.TYPO10_RG} `}>
          {moment(endDate).format("M.D")}
        </span>
      </div>
    </div>
  );
};

const UpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path d="M10 5.5H0L5 0.5L10 5.5Z" fill="var(--red40)" />
    </svg>
  );
};

const SorryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <path
        d="M3.48217 37.4407C2.33017 31.6807 9.08217 23.0407 12.6022 19.4407L24.3619 20.1607H24.6014L36.3611 19.4407C39.8811 23.0407 46.6331 31.6807 45.4811 37.4407C44.3291 43.2007 38.1213 44.3207 35.1614 44.1607L32.0414 37.4407L30.9508 38.9607H18.1219L16.9219 37.4407L13.8019 44.1607C10.842 44.3207 4.63417 43.2007 3.48217 37.4407Z"
        fill="#5268E9"
      />
      <path
        d="M34.8135 43.3619L33.2461 44.0592H25.8066C25.2466 43.8992 24.4144 43.2913 25.5664 42.1393C26.6306 41.0752 30.1156 38.6671 32.0283 37.36L34.8135 43.3619Z"
        fill="#FFCBA7"
      />
      <path
        d="M14.1631 43.3619L15.7295 44.0592H23.1699C23.7299 43.8992 24.5621 43.2913 23.4102 42.1393C22.3463 41.0754 18.8612 38.6683 16.9483 37.361L14.1631 43.3619Z"
        fill="#FFCBA7"
      />
      <circle cx="13.6669" cy="18.72" r="3.12" fill="#FFCBA7" />
      <circle cx="34.788" cy="18.72" r="3.12" fill="#FFCBA7" />
      <circle cx="24.4722" cy="16.08" r="12.48" fill="#262626" />
      <path
        d="M26.874 18.7197C28.3139 19.9197 31.914 22.2718 34.7939 22.0801L35.5254 21.8799C33.4367 25.8505 29.2746 28.5596 24.4766 28.5596C20.0528 28.5595 16.1694 26.2564 13.9531 22.7852C15.5716 22.2146 19.1034 20.7229 19.6748 19.1992C21.1949 19.8392 24.4746 21.0719 25.4346 20.8799L26.874 18.7197Z"
        fill="#FFCBA7"
      />
      <ellipse cx="22.1894" cy="25.4403" rx="1.08" ry="0.72" fill="#262626" />
      <ellipse cx="27.9472" cy="25.4403" rx="1.08" ry="0.72" fill="#262626" />
    </svg>
  );
};

export default OperationPeriodCards;
